/* Maison Laal theme — vanilla JS, no dependencies */
(function () {
  'use strict';
  var T = window.theme || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = T.moneyFormat || '${{amount}}';
    function delim(n, p, t, d) {
      p = p == null ? 2 : p; t = t || ','; d = d || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(p);
      var parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? d + parts[1] : '');
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), v = '';
    switch (m && m[1]) {
      case 'amount_no_decimals': v = delim(cents, 0); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'", '.'); break;
      default: v = delim(cents, 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  /* ---------- Drawers ---------- */
  var lastFocus;
  function openDrawer(drawer, overlay) {
    lastFocus = document.activeElement;
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-open'); drawer.classList.add('is-open'); });
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    drawer.focus();
  }
  function closeDrawer(drawer, overlay) {
    drawer.classList.remove('is-open'); overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    setTimeout(function () { overlay.hidden = true; }, 350);
    if (lastFocus) lastFocus.focus();
  }

  var cartDrawer = $('#CartDrawer'), cartOverlay = $('[data-drawer-overlay]');
  var menu = $('#MobileMenu'), menuOverlay = $('[data-menu-overlay]');

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cart-open]') && T.cartType === 'drawer' && cartDrawer) { e.preventDefault(); refreshCart().then(function () { openDrawer(cartDrawer, cartOverlay); }); }
    if (t.closest('[data-drawer-close]') || t === cartOverlay) closeDrawer(cartDrawer, cartOverlay);
    if (t.closest('[data-menu-open]') && menu) { openDrawer(menu, menuOverlay); $('[data-menu-open]').setAttribute('aria-expanded', 'true'); }
    if (t.closest('[data-menu-close]') || t === menuOverlay) { closeDrawer(menu, menuOverlay); $('[data-menu-open]').setAttribute('aria-expanded', 'false'); }
    if (t.closest('[data-search-open]')) { var o = $('[data-search-overlay]'); o.hidden = false; $('input[type=search]', o).focus(); }
    if (t.closest('[data-search-close]')) $('[data-search-overlay]').hidden = true;
    var mo = t.closest('[data-modal-open]'); if (mo) { var d = document.getElementById(mo.getAttribute('data-modal-open')); if (d && d.showModal) d.showModal(); }
    var mc = t.closest('[data-modal-close]'); if (mc) mc.closest('dialog').close();
    var qb = t.closest('[data-qty-minus],[data-qty-plus]');
    if (qb) { var inp = $('input', qb.closest('[data-qty]')); var v = parseInt(inp.value, 10) || 1; inp.value = Math.max(1, v + (qb.hasAttribute('data-qty-plus') ? 1 : -1)); }
    var ch = t.closest('[data-line-change]');
    if (ch) changeLine(ch.getAttribute('data-line'), parseInt(ch.getAttribute('data-qty'), 10));
    var ft = t.closest('[data-facets-toggle]');
    if (ft) { var p = $('[data-facets-panel]'); var open = p.classList.toggle('is-open'); ft.setAttribute('aria-expanded', open); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (cartDrawer && cartDrawer.classList.contains('is-open')) closeDrawer(cartDrawer, cartOverlay);
    if (menu && menu.classList.contains('is-open')) closeDrawer(menu, menuOverlay);
    var so = $('[data-search-overlay]'); if (so) so.hidden = true;
  });

  /* ---------- Cart ---------- */
  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    $$('[data-cart-count-bubble]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }
  function renderCart(cart) {
    updateCount(cart.item_count);
    var box = $('[data-cart-items]'); if (!box) return cart;
    if (!cart.items.length) { box.innerHTML = '<p class="drawer__empty">' + esc(T.strings.empty) + '</p>'; }
    else {
      box.innerHTML = cart.items.map(function (it, i) {
        var line = i + 1;
        var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1') + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240" alt="" width="80" loading="lazy">' : '';
        var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(' / ');
        return '<div class="dline"><a href="' + it.url + '" class="dline__img">' + img + '</a><div class="dline__info">' +
          '<a href="' + it.url + '" class="dline__title">' + esc(it.product_title) + '</a>' + (opts ? '<p class="dline__meta">' + opts + '</p>' : '') +
          '<p class="dline__price">' + formatMoney(it.final_line_price) + '</p>' +
          '<div class="dline__row"><div class="qty qty--sm"><button type="button" data-line-change data-line="' + line + '" data-qty="' + (it.quantity - 1) + '" aria-label="-">&minus;</button><span>' + it.quantity + '</span><button type="button" data-line-change data-line="' + line + '" data-qty="' + (it.quantity + 1) + '" aria-label="+">+</button></div>' +
          '<button type="button" class="link" data-line-change data-line="' + line + '" data-qty="0">' + esc(T.strings.remove) + '</button></div></div></div>';
      }).join('');
    }
    var sub = $('[data-cart-subtotal]'); if (sub) sub.textContent = formatMoney(cart.total_price);
    var ship = $('[data-free-shipping]');
    if (ship) {
      var goal = parseInt(ship.getAttribute('data-free-shipping'), 10), left = goal - cart.total_price;
      $('[data-ship-text]', ship).textContent = left > 0 ? 'You are ' + formatMoney(left) + ' away from free shipping' : 'You have unlocked free shipping';
      $('[data-ship-fill]', ship).style.width = Math.min(100, cart.total_price / goal * 100) + '%';
    }
    return cart;
  }
  function refreshCart() { return fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart); }
  function changeLine(line, qty) {
    return fetch(T.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: parseInt(line, 10), quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-facet-form]')) return;
    if (!form.matches('form[data-type="product-form"]')) return;
    if (T.cartType === 'page') return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]'), err = form.querySelector('[data-form-error]');
    if (btn) btn.classList.add('is-loading');
    fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { if (err) { err.textContent = res.j.description || res.j.message; err.hidden = false; } return; }
        if (err) err.hidden = true;
        return refreshCart().then(function () { openDrawer(cartDrawer, cartOverlay); });
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });
  if (cartDrawer) refreshCart();

  /* ---------- Product variants ---------- */
  $$('[data-product]').forEach(function (root) {
    var json = $('[data-variants]', root); if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = $('[data-variant-id]', root), btn = $('[data-add-btn]', root);
    function selected() { return $$('fieldset[data-option-index]', root).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function update() {
      var opts = selected();
      $$('fieldset[data-option-index]', root).forEach(function (fs, i) { var l = $('[data-option-value]', fs); if (l) l.textContent = opts[i]; });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      // mark unavailable values
      $$('fieldset[data-option-index]', root).forEach(function (fs, i) {
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[i] = inp.value;
          var ok = variants.some(function (x) { return x.available && x.options.every(function (o, j) { return o === test[j]; }); });
          inp.classList.toggle('is-unavailable', !ok);
        });
      });
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = T.strings.unavailable; } return; }
      if (idInput) idInput.value = v.id;
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? T.strings.addToCart : T.strings.soldOut; }
      var price = $('[data-price]', root);
      if (price) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        price.classList.toggle('price--sale', !!sale);
        price.innerHTML = '<span class="price__current">' + formatMoney(v.price) + '</span>' + (sale ? '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>' : '');
      }
      var sku = $('[data-sku]', root); if (sku) sku.textContent = v.sku ? 'SKU: ' + v.sku : '';
      if (v.featured_media) {
        var item = $('[data-media-id="' + v.featured_media.id + '"]', root);
        if (item) { var main = item.parentNode; if (window.innerWidth < 750) main.scrollTo({ left: item.offsetLeft, behavior: 'smooth' }); else main.insertBefore(item, main.firstChild); }
      }
      var url = root.getAttribute('data-url') + '?variant=' + v.id;
      history.replaceState({}, '', url);
    }
    root.addEventListener('change', function (e) { if (e.target.closest('fieldset[data-option-index]')) update(); });
    if ($$('fieldset[data-option-index]', root).length) update();

    // mobile gallery dots
    var main = $('.gallery__main', root), dots = $$('.gallery__dots span', root);
    if (main && dots.length) main.addEventListener('scroll', function () {
      var i = Math.round(main.scrollLeft / main.clientWidth);
      dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
    }, { passive: true });
  });

  /* ---------- Recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var inner = $('[data-recommendations]', d);
      if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; observe(el); }
      else { var s = el.closest('.shopify-section'); if (s) s.hidden = true; }
    });
  });

  /* ---------- Facets autosubmit ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });

  /* ---------- Header ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    $$('.nav__item.has-dropdown', header).forEach(function (li) {
      var a = $('.nav__link', li);
      li.addEventListener('mouseenter', function () { a.setAttribute('aria-expanded', 'true'); });
      li.addEventListener('mouseleave', function () { a.setAttribute('aria-expanded', 'false'); });
      li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) a.setAttribute('aria-expanded', 'false'); });
      li.addEventListener('focusin', function () { a.setAttribute('aria-expanded', 'true'); });
    });
  }

  /* ---------- Announcement rotator ---------- */
  $$('[data-rotator]').forEach(function (el) {
    var slides = $$('.announce__slide', el); if (slides.length < 2) return;
    var i = 0, ms = parseInt(el.getAttribute('data-interval'), 10) || 4000;
    setInterval(function () { slides[i].classList.remove('is-active'); i = (i + 1) % slides.length; slides[i].classList.add('is-active'); }, ms);
  });

  /* ---------- Reveal ---------- */
  var io = ('IntersectionObserver' in window) && document.body.classList.contains('has-animations') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ? new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px' })
    : null;
  function observe(scope) { $$('.reveal', scope).forEach(function (el) { if (io) io.observe(el); else el.classList.add('is-visible'); }); }
  observe(document);
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });

  /* ---------- WhatsApp ordering: keep selected variant in the message ---------- */
  $$('[data-product]').forEach(function (root) {
    var wa = $('[data-whatsapp-order]', root);
    if (!wa) return;
    function updateWhatsAppLink() {
      var title = wa.getAttribute('data-product-title') || document.title;
      var url = wa.getAttribute('data-product-url') || window.location.href.split('?')[0];
      var variantInput = $('[data-variant-id]', root);
      var variantId = variantInput && variantInput.value;
      var chosen = $$('fieldset[data-option-index]', root).map(function (fs) {
        var checked = $('input:checked', fs);
        var legend = $('legend', fs);
        var label = legend ? legend.childNodes[0].textContent.replace(':','').trim() : 'Option';
        return checked ? label + ': ' + checked.value : '';
      }).filter(Boolean).join(' / ');
      var message = 'Hi Meerab Boutique, I would like to order: ' + title +
        (chosen ? ' (' + chosen + ')' : '') +
        (variantId ? ' — Variant ID: ' + variantId : '') + '. Product: ' + url;
      wa.href = 'https://wa.me/923060286868?text=' + encodeURIComponent(message);
    }
    root.addEventListener('change', function (e) {
      if (e.target.closest('fieldset[data-option-index]')) updateWhatsAppLink();
    });
    updateWhatsAppLink();
  });

  /* ---------- Recently viewed products (local to this customer's browser) ---------- */
  $$('[data-recently-viewed]').forEach(function (section) {
    var current = section.getAttribute('data-current-handle');
    var grid = $('[data-recently-viewed-grid]', section);
    if (!current || !grid) return;
    var key = 'meerab_recently_viewed_v1', handles = [];
    try { handles = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { handles = []; }
    handles = handles.filter(function (h) { return typeof h === 'string' && h !== current; });
    var previous = handles.slice(0, 4);
    handles.unshift(current);
    try { localStorage.setItem(key, JSON.stringify(handles.slice(0, 8))); } catch (e) {}
    if (!previous.length) return;
    section.hidden = false;
    Promise.all(previous.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { if (!r.ok) throw new Error('Product unavailable'); return r.json(); })
        .catch(function () { return null; });
    })).then(function (products) {
      products.filter(Boolean).forEach(function (product) {
        var card = document.createElement('article'); card.className = 'recently-viewed__card';
        var link = document.createElement('a'); link.href = product.url;
        if (product.featured_image) {
          var img = document.createElement('img'); img.src = product.featured_image + (product.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=480';
          img.alt = product.title || ''; img.loading = 'lazy'; img.width = 480; img.height = 640; link.appendChild(img);
        }
        var title = document.createElement('h3'); title.className = 'recently-viewed__title'; title.textContent = product.title || '';
        link.appendChild(title); card.appendChild(link);
        var price = document.createElement('p'); price.className = 'recently-viewed__price'; price.textContent = formatMoney(product.price || 0);
        card.appendChild(price); grid.appendChild(card);
      });
      if (!grid.children.length) section.hidden = true;
    }).catch(function () { section.hidden = true; });
  });

  /* ---------- Product style spotlight: recurring, non-purchase social prompt ---------- */
  $$('[data-style-note-toast]').forEach(function (toast) {
    var title = $('[data-style-note-title]', toast);
    var body = $('[data-style-note-text]', toast);
    var link = $('[data-style-note-link]', toast);
    var close = $('[data-style-note-close]', toast);
    var notes = [
      { title: 'Considering this look?', text: 'Ask our team about sizing, fabric, or product details.', link: 'Ask on WhatsApp', href: 'https://wa.me/923060286868' },
      { title: 'Find your perfect fit', text: 'Need help choosing a size? We are happy to help.', link: 'Chat with us', href: 'https://wa.me/923060286868' },
      { title: 'A little style inspiration', text: 'Take another look at this design or explore more styles.', link: 'Explore collection', href: '/collections/all' }
    ];
    var stopped = false, visible = false, index = Math.floor(Math.random() * notes.length), hideTimer = null, cycleTimer = null;
    function showNote() {
      if (stopped || document.hidden) { scheduleNext(); return; }
      var note = notes[index % notes.length]; index += 1;
      if (title) title.textContent = note.title;
      if (body) body.textContent = note.text;
      if (link) { link.textContent = note.link; link.href = note.href; }
      toast.hidden = false; visible = true;
      hideTimer = window.setTimeout(function () { toast.hidden = true; visible = false; }, 8500);
      scheduleNext();
    }
    function scheduleNext() {
      if (stopped) return;
      if (cycleTimer) window.clearTimeout(cycleTimer);
      cycleTimer = window.setTimeout(showNote, 30000);
    }
    // First appearance after a short delay, then every 30 seconds while this product page is open.
    window.setTimeout(showNote, 6500);
    if (close) close.addEventListener('click', function () {
      toast.hidden = true; visible = false; stopped = true;
      if (hideTimer) window.clearTimeout(hideTimer);
      if (cycleTimer) window.clearTimeout(cycleTimer);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && visible) { toast.hidden = true; visible = false; }
    });
  });

  /* ---------- Gentle first-visit welcome message ---------- */
  var welcome = $('[data-welcome-toast]');
  if (welcome) {
    var welcomeKey = 'meerab_welcome_dismissed_v1';
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(welcomeKey) === '1'; } catch (e) {}
    if (!dismissed) {
      window.setTimeout(function () {
        if (!document.hidden) welcome.hidden = false;
      }, 1800);
    }
    var closeWelcome = $('[data-welcome-close]', welcome);
    if (closeWelcome) closeWelcome.addEventListener('click', function () {
      welcome.hidden = true;
      try { sessionStorage.setItem(welcomeKey, '1'); } catch (e) {}
    });
  }
})();
